import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { useErrorStore } from '../state/useErrorStore';

const AppErrorAlert = () => {
  const error = useErrorStore(s => s.httpError);
  const clearHttpError = useErrorStore(s => s.clearHttpError);
  const { t } = useTranslation();
  const handleClose = useCallback(() => clearHttpError(), [clearHttpError]);

  if (!error) return null;

  return (
    <AlertDialog open onOpenChange={(open: boolean) => !open && handleClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('errors.awsError.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('errors.awsError.description', {
              detail: t(`errors.coded.${error?.innerException?.response?.status}`),
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleClose}>Ok</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AppErrorAlert;
